import React from "react";

const HomeIndex = () => {
    return <div style={{ padding: '25px'}}>Home</div>
    
}

export default HomeIndex